import { DEFAULT_SPORT_ID } from '@sportybot-web/services/stats-api/constants';
import { formatScheduleDate } from '@sportybot-web/utils/date';
import { z } from 'zod';

export const gameViewSearchSchema = z.object({
  date: z.iso
    .date()
    .optional()
    .default(() => formatScheduleDate()),
  gamePk: z.coerce.number(),
  sportId: z.number().default(DEFAULT_SPORT_ID),
});

export type GameViewParams = z.infer<typeof gameViewSearchSchema>;

export const customClippingPanelTabSchema = z.enum(['key-plays', 'my-clips']);

export type CustomClippingPanelTab = z.infer<typeof customClippingPanelTabSchema>;

export const customClipViewSearchSchema = z.object({
  audioOffset: z.coerce.number().catch(0).default(0),
  clipEnd: z.coerce.number().optional(),
  clipStart: z.coerce.number().optional(),
  panelTab: customClippingPanelTabSchema.default('key-plays'),
  selectedAtBatIndex: z.number().int().nonnegative().optional(),
  selectedAudioTrack: z.string().optional(),
  selectedFeedId: z.string().optional(),
});
